<template>
  <div class="add-player-form">
    <input
      type="text"
      v-model="playerName"
      placeholder="Name eingeben"
      class="player-input"
      @keyup.enter="addPlayer"
    />
    <div class="gender-toggle">
      <button
        class="gender-btn"
        :class="{ active: playerGender === 'male' }"
        @click="playerGender = 'male'"
      >
        <i class="fas fa-mars"></i>
      </button>
      <button
        class="gender-btn"
        :class="{ active: playerGender === 'female' }"
        @click="playerGender = 'female'"
      >
        <i class="fas fa-venus"></i>
      </button>
    </div>
    <button class="add-btn" @click="addPlayer">
      <i class="fas fa-plus"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: "AddPlayerForm",
  data() {
    return {
      playerName: "",
      playerGender: "male",
    };
  },
  emits: ["add-player"],
  methods: {
    addPlayer() {
      if (this.playerName.trim() === "") {
        this.$emit("invalid-input", "Bitte gib einen Namen ein.");
        return;
      }

      this.$emit("add-player", {
        name: this.playerName.trim(),
        gender: this.playerGender,
      });

      this.playerName = "";
    },
  },
};
</script>

<style scoped>
.add-player-form {
  background-color: var(--secondary-bg);
  border-radius: var(--border-radius-md);
  padding: var(--spacing-md);
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  margin-top: var(--spacing-sm);
}

.player-input {
  flex: 1;
  width: 100%;
  background-color: var(--card-bg);
  border: none;
  border-radius: var(--border-radius-sm);
  padding: var(--spacing-md);
  color: var(--text-color);
  font-size: var(--font-size-md);
}

.player-input:focus {
  outline: 1px solid var(--accent-color);
}

.gender-toggle {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px;
  background-color: var(--card-bg);
  border-radius: var(--border-radius-sm);
}

.gender-btn {
  padding: 6px 10px;
  border-radius: 6px;
  border: none;
  background: none;
  color: #8a8a8a;
  cursor: pointer;
  transition: all var(--transition-fast);
}

.gender-btn.active {
  background-color: var(--accent-color);
  color: var(--bg-color);
}

.add-btn {
  background-color: var(--accent-color);
  color: var(--bg-color);
  border: none;
  width: 40px;
  height: 40px;
  border-radius: var(--border-radius-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all var(--transition-fast);
}

.add-btn:hover {
  opacity: 0.9;
}
</style>
